import { render, staticRenderFns } from "./TrafficDetails.vue?vue&type=template&id=78ffc302&scoped=true&"
import script from "./TrafficDetails.vue?vue&type=script&lang=js&"
export * from "./TrafficDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ffc302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ffc302')) {
      api.createRecord('78ffc302', component.options)
    } else {
      api.reload('78ffc302', component.options)
    }
    module.hot.accept("./TrafficDetails.vue?vue&type=template&id=78ffc302&scoped=true&", function () {
      api.rerender('78ffc302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/Statistics/TrafficDetails.vue"
export default component.exports